import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { useSnackbar } from 'notistack';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, Chip } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { DropzoneArea } from "material-ui-dropzone";
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import { AssetInfo } from '../components'
import { TechSpecsNav } from "../../elements";
import { checkApiStatus, checkPermission } from "../../utils_v2";
import FilePreview from "../../shared_elements/FilePreview";
import { DeletePopUp, EmptyCollection, PageLoader, Pagination, RevisionHistory, STableLoader } from "../../shared_elements";
import { globalDeleteService, globalGetService, globalPostService, globalPutService } from "../../../globalServices";
import useAssetInfo from '../hooks/useAssetInfo';
import { backendDateFormat, displayDateFormat, fieldDateFormat } from "../../../constants";
import { regexConstants } from "../../../constants/regEx";
import { downloadFile } from "../../../utils";
import AddIcon from '@material-ui/icons/Add';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const TechSpecHD = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '140px' }}>Action(s)</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Attachments</TableCell>
            </TableRow>
        </TableHead>
    )
}

const TechSpecListing = ({ item, onEdit, onDelete, onView, assetInfoData }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field]
        })
    }
    return (
        <TableRow>
            <TableCell align="left" style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
                <ul className="list-inline" style={{ width: '160px' }}>
                    {item?.file?.name ?
                        <li className="list-inline-item hover-inline" onClick={() => downloadFile({ ...item, image: item?.file?.url, file_name: item?.file?.name })}>
                            <Tooltip title='Download' arrow><GetAppIcon color="primary" fontSize="small" /></Tooltip>
                        </li> : null
                    }
                    {item?.file ?
                        <li className="list-inline-item hover-inline" onClick={() => onView(item)}>
                            <Tooltip title='View' arrow><VisibilityIcon style={{ cursor: 'pointer' }} color='primary' fontSize='small' /></Tooltip>
                        </li> : null}
                    {checkPermission('technical_specs', 'archived_tech_specs', 'U') ?
                        <li className="list-inline-item hover-inline" onClick={onEdit}>
                            <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                        </li> : null}
                    {checkPermission('technical_specs', 'archived_tech_specs', 'D') ?
                        <li className="list-inline-item hover-inline" onClick={onDelete}>
                            <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                        </li> : null}
                    <li className='list-inline-item hover-inline'>
                        <RevisionHistory id={item.id} assetInfoData={assetInfoData} isExp={false} buttonType={true} url={`audit/console/amarchivedreports/?action=0,1,2&object_id=${item?.id}`} />
                    </li>
                </ul>
            </TableCell>
            <TableCell><div style={{width:"120px"}}>{item?.name || '--'}</div></TableCell>
            <TableCell><div style={{width:"120px"}}>{moment(item?.revision_date).format(displayDateFormat) || '--'}</div></TableCell>
            <TableCell onClick={(e) => e.stopPropagation()}>
                {item?.remarks && item?.remarks?.length > 30 ? (
                    <div style={{ width: '250px' }}>
                        {showMore[item?.field] ? (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
                            </span>
                        ) : (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
                            </span>
                        )}
                    </div>
                ) : (
                    <div style={{ width: '250px' }} dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
                )}
            </TableCell>
            <TableCell><div style={{width:"250px"}}>{item?.file?.name ? item?.file?.name : "--"}</div></TableCell>
        </TableRow>
    )
}
const AddTechSpec = ({ addEditTechSpec, toggleModalFn, getResponseBack, params, setPreviewDocs, getListApi }) => {
    const [techSpec, setTechSpec] = useState(addEditTechSpec?.data?.id ? addEditTechSpec?.data : {})
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({})
    const [deleteTechSpec, setDeleteTechSpec] = useState({ modal: false, data: null });
    const { enqueueSnackbar } = useSnackbar();
    const onAddEditSubModule = () => {
        if (techSpec?.attachments?.length > 1) {
            enqueueSnackbar("Maximum allowed number of file exceeded. Only 1 allowed.", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
        } else {
            let validateInput = {}
            validateInput = {
                name: techSpec?.name?.trim()?.length ? '' : 'Please enter Name',
                revision_date: techSpec?.revision_date ? '' : 'Please enter Date',
                attachments: techSpec?.attachments?.length || techSpec?.file?.name ? '' : 'Please upload the attachments.'
            }
            if (techSpec?.revision_date && !moment(techSpec?.revision_date).isValid()) {
                validateInput = {
                    ...validateInput,
                    revision_date: 'Please enter valid Date',
                }
            }
            if (Object.keys(validateInput).every(k => validateInput[k] === '')) {
                const formdata = new FormData()
                if (techSpec?.attachments?.length > 0) {
                    techSpec.attachments.forEach(element => {
                        formdata.append('file', element);
                    });
                }
                formdata.append('name', techSpec.name)
                formdata.append('revision_date', techSpec.revision_date)
                formdata.append('remarks', techSpec.remarks||'')
                setLoading(true)
                if (techSpec.id) {
                    globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/archive-reports/${techSpec.id}/`, formdata)
                        .then(response => {
                            if (checkApiStatus(response)) {
                                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                                getResponseBack();
                            }
                        })
                } else {
                    globalPostService(`console/v2/${params.type}/${params.aircraft_slug}/archive-reports/`, formdata)
                        .then(response => {
                            if (checkApiStatus(response)) {
                                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                                getResponseBack();
                            }
                        })
                }
            }
            else {
                setError(validateInput)
            }
        }
    }
    const deleteModuleAttachment = (item) => {
        setLoading(true)
        globalDeleteService(`console/attachments/${item.uuid}/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    const updatedAttachments = techSpec.attachments.filter(att => att.uuid !== item.uuid);
                    setTechSpec({ ...techSpec, attachments: updatedAttachments });
                    setDeleteTechSpec({ modal: false, data: null })
                    getListApi();
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
                setLoading(false)
            })
    };
    const onDeleteChip = (file, index) => {
        setTechSpec({ ...techSpec, attachments: techSpec?.attachments?.filter(item => item?.name !== file?.name) });
    }
    const onDropFiles = (file) => {
        setTechSpec({ ...techSpec, attachments: file });
        setError({ ...error, attachments: '' })
    }
    const onFieldChange = (key, value) => { setTechSpec({ ...techSpec, [key]: value }) }
    return (
        <>
            <Dialog
                open={addEditTechSpec.modal}
                onClose={toggleModalFn}
                className='console-management-modal'
                maxWidth="md"
            >
                <DialogTitle id="scroll-dialog-title">
                    {techSpec?.id ? 'Edit ' : 'Add '} Archived Tech Specs
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={1}>
                        <Grid item md={8}>
                            <TextField
                                required
                                id='name'
                                label='Name'
                                value={techSpec?.name || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 250 }}
                                onChange={(e) => { e.target.value ? regexConstants.alphanumericWithSpace.test(e.target.value) ? onFieldChange('name', e.target.value) : e.preventDefault() : onFieldChange('name', null) }}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                error={error?.name}
                                helperText={error?.name || ''}
                                onFocus={() => setError({ ...error, 'name': '' })}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    required
                                    margin="normal"
                                    name="revision_date"
                                    label="Date"
                                    format={fieldDateFormat}
                                    fullWidth
                                    disableFuture
                                    InputLabelProps={{ shrink: true }}
                                    value={techSpec?.revision_date || null}
                                    onChange={(data, value) => { onFieldChange('revision_date', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'revision_date': '' }) }}
                                    inputVariant='outlined'
                                    error={error?.revision_date ? true : false}
                                    helperText={error?.revision_date || ''}
                                    onFocus={() => setError({ ...error, 'revision_date': '' })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                id='remarks'
                                label='Description'
                                value={techSpec?.remarks || ''}
                                fullWidth
                                margin="normal"
                                multiline
                                rows={3}
                                inputProps={{ maxLength: 250 }}
                                onChange={(e) => {onFieldChange('remarks', e.target.value)}}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'

                            />
                        </Grid>
                        <Grid item md={12}>
                            <div>
                                <DropzoneArea
                                    acceptedFiles={['application/pdf']}
                                    filesLimit={1}
                                    maxFileSize={104857600}
                                    showPreviewsInDropzone={false}
                                    useChipsForPreview={true}
                                    showPreviews={true}
                                    onDelete={(item, index) => onDeleteChip(item, index)}
                                    dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                    dropzoneClass="drag-drop-cnt"
                                    showAlerts={['info', 'error']}
                                    alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                    clearOnUnmount={true}
                                    onDrop={(file) => { onDropFiles(file) }}
                                />
                            </div>
                            <span style={{ fontSize: '11px' }} className='file-upload-limit' > Note : Mandatory field — upload 1 file, Supported extension(.pdf only)</span> <br />
                            {error?.attachments ? <p className="error-msg">{error?.attachments}</p> : null}
                            {techSpec?.id && techSpec?.file?.name && techSpec?.file?.url && techSpec?.attachments?.length !== 1 && (
                                <p><Tooltip title={techSpec?.file?.name}><Chip style={{ maxWidth: '400px', cursor: 'pointer' }} label={techSpec?.file?.name} size='small' /></Tooltip></p>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                    <Button disabled={isLoading} onClick={onAddEditSubModule} color='primary' size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={24} /> : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
            {deleteTechSpec.modal ?
                <DeletePopUp
                    modal={deleteTechSpec.modal}
                    title={`Delete Archived Tech Specs (${deleteTechSpec?.data?.name})`}
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteTechSpec({ modal: false, data: null })}
                    deleteRecordFn={() => deleteModuleAttachment(deleteTechSpec?.data)}
                    isLoading={isLoading}
                /> : null
            }
        </>
    )
}
function ArchievedTechSpec({ params }) {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
    const { enqueueSnackbar, } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [techSpecList, setTechSpecList] = useState({ list: [], pagination: null });
    const [addEditTechSpec, setAddEditTechSpec] = useState({ modal: false, data: null });
    const [deleteTechSpec, setDeleteTechSpec] = useState({ modal: false, data: null });
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    const [previewDocs, setPreviewDocs] = useState({})
    useEffect(() => {
        getTechSpecList({per_page:50}, 'skeletonLoader');
    }, []);
    const getTechSpecList = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/archive-reports/`, query)
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
                if (checkApiStatus(response)) {
                    const data = response.data.data;
                    setTechSpecList({ ...data, pagination: data.pagination ? { ...data.pagination, page: data.pagination?.page || 1 } : data.pagination })
                }
            })
    }

    const onDeleteTechSpec = () => {
        setLoading(true);
        globalDeleteService(`console/v2/${params.type}/${params.aircraft_slug}/archive-reports/${deleteTechSpec.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteTechSpec({ modal: false, data: null })
                    getTechSpecList({ page: 1, per_page: techSpecList?.pagination?.per_page || 50 }, 'pageLoader');
                }
                setLoading(false);
            })
    }
    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 162}px` }} >
                <TechSpecsNav />
                <div className="tech-specs-content">
                    {isLoading ? <PageLoader /> : null}
                    {skeletonLoader ? <STableLoader count={8} /> :
                        <div style={{ padding: '0px 10px' }}>
                            <Paper elevation={0} className="console-paper" style={{ padding: '5px 8px' }}>
                                <ul className="list-inline" style={{ textAlign: "right" }}>
                                    {checkPermission('technical_specs', 'archived_tech_specs', 'C') ?
                                        <li>
                                            <Button onClick={() => setAddEditTechSpec({ modal: true, data: {} })} color='primary' size='small' variant='contained'> <AddIcon style={{ fontSize: '1.15rem' }} />Add</Button>
                                        </li> : null}
                                </ul>
                            </Paper>
                                <Paper square>
                                    <div style={{height:`${(window.innerHeight -  (techSpecList?.list?.length ? 275 : 225)) - navTitleOffset}px`,overflow:'auto',marginTop: "3px" }}>
                                    <Table className='mui-table-format' stickyHeader>
                                        <TechSpecHD />
                                        <TableBody>
                                            {techSpecList?.list?.length ?
                                                techSpecList?.list?.map(item =>
                                                    <TechSpecListing
                                                        onEdit={() => setAddEditTechSpec({ data: item, modal: true })}
                                                        onDelete={() => setDeleteTechSpec({ data: item, modal: true })}
                                                        onView={() => setPreviewDocs({ data: item, modal: true })}
                                                        item={item}
                                                        assetInfoData={assetInfoData}
                                                    />) : null
                                            }
                                        </TableBody>
                                    </Table>
                                    {!techSpecList?.list?.length && !isLoading ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                    </div>
                                </Paper>
                            {techSpecList?.pagination ?
                                <Paper square>
                                    <Pagination
                                        pagination={techSpecList.pagination}
                                        onChangePage={(event, newPage) => getTechSpecList({ page: newPage + 1, per_page: techSpecList.pagination.per_page }, 'pageLoader')}
                                        onChangeRowsPerPage={(event) => getTechSpecList({ page: 1, per_page: event.target.value }, 'pageLoader')}
                                    />
                                </Paper>
                                : null}
                        </div>}
                </div>
                {addEditTechSpec?.modal ?
                    <AddTechSpec
                        params={params}
                        addEditTechSpec={addEditTechSpec}
                        toggleModalFn={() => setAddEditTechSpec({})}
                        getResponseBack={() => { setAddEditTechSpec({}); getTechSpecList({ page: 1, per_page: techSpecList?.pagination?.per_page || 50 }) }}
                        setPreviewDocs={setPreviewDocs}
                        getListApi={getTechSpecList}
                    /> : null
                }
                {deleteTechSpec?.modal ?
                    <DeletePopUp
                        modal={deleteTechSpec.modal}
                        title='Delete Archived Tech Specs'
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setDeleteTechSpec({ modal: false, data: null })}
                        deleteRecordFn={onDeleteTechSpec}
                    /> : null
                }
                {previewDocs?.modal ?
                    <FilePreview
                        downloadFile={downloadFile}
                        toggleModalFn={() => setPreviewDocs({ modal: false, data: null })}
                        fileInfo={{ file_name: previewDocs?.data?.file?.name, extension: previewDocs?.data?.file?.extension, image: previewDocs?.data?.file?.url }}
                    /> : null
                }
            </Paper>
        </section>

    )
}
export default withRouter(ArchievedTechSpec)